import { useQuery } from '@tanstack/react-query';
import { usePrismAuth } from '@/lib/prism-bridge';
import { getApiKeyStatus } from './apiKeys';
import { queryKeys } from './queryKeys';

/**
 * Whether the authenticated developer has an API key (GET /dev-portal/api-keys).
 * Org-scoped query key (re-fetches on org switch). Gated on `isReady` (token + org id both
 * synced from Prism) — firing before the org id lands would 400 and show an error/retry page.
 */
export function useApiKeyStatus() {
  const { token, orgId, isReady } = usePrismAuth();
  return useQuery({
    queryKey: queryKeys.apiKeys.status(orgId),
    queryFn: () => getApiKeyStatus({ token, orgId }),
    enabled: isReady,
  });
}
